<template>
    <div>
        <div class="flex flex-col mb-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    #
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {{ $t('Name') }}
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {{ $t('Department') }}
                                </th>
                                <th scope="col" class="relative px-6 py-3">
                                    &nbsp;
                                </th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                            <template v-if="customer.consultants && customer.consultants.length > 0">
                                <ConsultantLine
                                    :detach-endpoint="route('customer-consultants.detach',{'customer':customer.id,'consultant':consultant.id})"
                                    :consultant="consultant" v-for="consultant in customer.consultants"
                                    :can-delete="customer.consultants.length > 1"></ConsultantLine>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="6" class="px-6 py-4 whitespace-nowrap text-center">
                                        {{ $t('No data available.') }}
                                    </td>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <ConsultantAttachForm :available-consultants="availableConsultants"
                              @attached="consultantAttached"
                              :attach-endpoint="route('customer-consultants.attach',{'customer':customer.id})"></ConsultantAttachForm>
    </div>
</template>

<script setup>
import ConsultantAttachForm from "./ConsultantAttachForm";
</script>

<script>

import {Link} from "@inertiajs/vue3";
import ConsultantLine from '@/Components/ConsultantManagerConsultantLine.vue'

export default {
    name: "ConsultantManager",
    components: {
        Link,
        ConsultantLine,
    },
    props: {
        customer: Object,
        availableConsultants: Object,
    },
    computed: {},
    data() {
        return {};
    },
    methods: {
        consultantAttached(){
            this.$inertia.reload(['customer']);
        }
    },
}
</script>

<style scoped>

</style>
